import { ICountryCode } from '../../../../../interfaces/IBrands';
const engShortWeekDays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
const engMonths = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
const WEEKDAYS_SHORT: Record<ICountryCode, string[]> = {
    de: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    ru: ['Нд', 'Пн', 'Аў', 'Ср', 'Чц', 'Пт', 'Сб'],
    it: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
    fr: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    nl: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
    br: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    us: engShortWeekDays,
    au: engShortWeekDays,
    cn: [],
    uk: engShortWeekDays,
};
//Sunday is 0
const FIRST_DAY_OF_WEEK: Record<ICountryCode, number> = {
    de: 1,
    ru: 1,
    it: 1,
    fr: 1,
    nl: 1,
    br: 0,
    us: 0,
    au: 1,
    cn: 0,
    uk: 1,
};
const MONTHS: Record<ICountryCode, string[]> = {
    de: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
    ],
    fr: [],
    nl: [],
    br: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
    ],
    us: engMonths,
    au: engMonths,
    cn: [],
    uk: engMonths,
    ru: [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь',
    ],
    it: [
        'Gennaio',
        'Febbraio',
        'Marzo',
        'Aprile',
        'Maggio',
        'Giugno',
        'Luglio',
        'Agosto',
        'Settembre',
        'Ottobre',
        'Novembre',
        'Dicembre',
    ],
};
const getDateFormatByLocale = (locale: ICountryCode) => {
    return locale === 'us' ? 'MM/dd/yyyy' : 'dd.MM.yyyy';
};
export { WEEKDAYS_SHORT, FIRST_DAY_OF_WEEK, MONTHS, getDateFormatByLocale };
